import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

import { CasinoTheme, DSClassNames, FeatureNames, OverFlowTypes } from '@frontend/casino-ui/shared';

import { themeScrollbarUISettings } from './theme-scrollbar-settings';

@Directive({
    selector: '[csScrollbar]',
    standalone: true,
})
export class ScrollbarWrapperDirective implements OnInit {
    @Input() horizontalOverflowType = OverFlowTypes.HIDDEN;
    @Input() verticalOverflowType = OverFlowTypes.AUTO;
    @Input() featureName = FeatureNames.EGV;
    @Input() currentTheme: CasinoTheme = 'bwin';

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
    ) {}

    ngOnInit(): void {
        this.renderer.addClass(this.el.nativeElement, DSClassNames.DSScrollbar);
        const themeScrollbarUISetting = themeScrollbarUISettings[this.currentTheme];
        if (themeScrollbarUISetting?.scrollbar?.[this.featureName]?.isInverse) {
            this.renderer.addClass(this.el.nativeElement, DSClassNames.DSScrollbarInverse);
        }
        this.renderer.setStyle(this.el.nativeElement, 'overflow-x', this.horizontalOverflowType);
        this.renderer.setStyle(this.el.nativeElement, 'overflow-y', this.verticalOverflowType);
    }
}
